import makeStyles from "@mui/styles/makeStyles";

import { SHORT_DAYS } from "../../../consts/strings";
import { palette } from "../../../theme/palette";

import { View } from "../../Base";
import { DayChips } from "../../DayChips/DayChips";
import StyledChip from "../../DayChips/StyledChip";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  header: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  sourceDaysContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "10px",
    gap: "2px",
  },
  targetDaysContainer: {
    display: "flex",
    marginBottom: "10px",
    gap: "2px",
  },
});

export const CopyDriverWorkScheduleContent = ({
  sourceDayOfWeek,
  targetDaysOfWeek,
  onSourceDayChange,
  onTargetDayChange,
}) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      <View className={styles.header}>Copy From:</View>
      <View className={styles.sourceDaysContainer}>
        <DayChips
          onDaySelected={({ value }) => {
            onSourceDayChange(value);
            onTargetDayChange({
              ...targetDaysOfWeek,
              [value]: false,
            });
          }}
          selected={sourceDayOfWeek}
        />
      </View>
      <View className={styles.header}>Copy To:</View>
      <View className={styles.targetDaysContainer}>
        {[1, 2, 3, 4, 5, 6, 0].map((dayOfWeek, index) => (
          <StyledChip
            dark
            size={"small"}
            clickable
            label={SHORT_DAYS[dayOfWeek]}
            key={index}
            onClick={() => {
              onTargetDayChange({
                ...targetDaysOfWeek,
                [dayOfWeek]: !targetDaysOfWeek[dayOfWeek],
              });
            }}
            style={
              dayOfWeek === sourceDayOfWeek
                ? {
                    backgroundColor: palette.dpdLightGrey,
                    pointerEvents: "none",
                    color: palette.typography.white.high,
                  }
                : targetDaysOfWeek[dayOfWeek]
                ? {
                    backgroundColor: palette.dpdRed,
                    color: palette.typography.white.high,
                  }
                : {}
            }
          />
        ))}
      </View>
    </View>
  );
};
